import { PersonInfo } from "ui";

import { OrderPersonInfoAtomProps } from "../OrdersTable.types";

import styles from "../OrdersTable.module.scss";

const getUrl = (imageUrl?: string) => {
  if (imageUrl) return { url: imageUrl };
  return null;
};

export const OrderPersonCell = ({
  imageUrl,
  name
}: OrderPersonInfoAtomProps) => {
  return (
    <PersonInfo
      image={getUrl(imageUrl)}
      personName={name}
      nameClassName={styles.ordersTable_name}
      wrapperClassName={styles.ordersTable_nameWrapper}
      dimensions={{ width: 24, height: 24, borderRadius: "100px" }}
    />
  );
};
